import { useCallback, useRef, useState } from 'react';
import API from '../services/api';

// The invoice, quote and conduce builders price a line when its product is picked, using the client's special price if there is
// one. Picking the CLIENT afterwards (or changing it) has to re-price the lines already there, or they keep the list price.
//   items / setItems: the builder's lines. A line is re-priced only if it has a product and its price was not typed by hand
//   (the builder sets `priceEdited: true` when the person edits a price; picking a product clears it).
//   repriceFor(clientId, clientName) → re-prices the lines and sets `priceNote` ("Se actualizaron 2 precios ...") when any changed.
export function useClientRepricing(items, setItems) {
  const latestClient = useRef('');
  const [priceNote, setPriceNote] = useState('');

  const repriceFor = useCallback(async (clientId, clientName) => {
    latestClient.current = clientId;
    setPriceNote('');
    const results = await Promise.all(items.map(async (it, index) => {
      if (!it.product || it.priceEdited) return null;
      try {
        const { data } = await API.get('/client-prices/resolve', { params: { client: clientId, product: it.product } });
        return { index, product: it.product, price: data.price };
      } catch (err) {
        console.error('Error resolving client price:', err);
        return null;
      }
    }));
    if (latestClient.current !== clientId) return; // the client changed again while this was loading: that answer wins
    const changes = results.filter(r => r && Number(items[r.index]?.unitPrice) !== Number(r.price));
    if (!changes.length) return;
    setItems(prev => prev.map((it, i) => {
      const change = changes.find(c => c.index === i && c.product === it.product);
      return change && !it.priceEdited ? { ...it, unitPrice: change.price } : it;
    }));
    const who = clientName || 'este cliente';
    setPriceNote(`${changes.length === 1 ? 'Se actualizó 1 precio' : `Se actualizaron ${changes.length} precios`} a los de ${who}. Los precios que escribiste a mano no se tocan.`);
  }, [items, setItems]);

  return { priceNote, repriceFor };
}
